<template>
    <div class="cart-card">
        <div class="cart-card-img">
            <img :src="require('@/assets/img_site/slide2_main.svg')" alt="">
        </div>
        <div class="cart-card-info">
            <div class="title">Xiaomi Mi Notebook Pro 2019</div>
            <div class="price">
                <div>Цена:</div>
                <span>22 431 грн</span>
            </div>
            <div class="amount">
                <div>Количество:</div>
                <span>3</span>
            </div>
        </div>
        <div class="cart-card-remove">
            <x-circle-icon size="1x" class="custom-class"></x-circle-icon>
        </div>
    </div>
</template>

<script>
    import { XCircleIcon } from 'vue-feather-icons'

    export default {
        name: "CartCard",
        components: {
            XCircleIcon
        }
    }
</script>

<style scoped lang="scss">
    .cart-card {
        display: flex;
        width: 385px;
        padding: 24px 16px 12px;
        background: #FFFFFF;

        &-img {
            width: 80px;
            height: 80px;
            margin-right: 15px;
            img {
                height: 100%;
                width: 100%;
            }
        }
        &-info {
            color: #686F83;
            font-size: 14px;
            line-height: 21px;
            .title {
                color: #3F4450;
                font-size: 16px;
            }
            >div {
                display: flex;
                div {
                    &:first-child {
                        min-width: 88px;
                        margin-right: 16px;

                    }
                }
            }


        }
        &-remove {
            margin-left: 8px;
            cursor: pointer;
            svg {
                color: #C6CED7;
            }
        }
    }

</style>